import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Scheduler from "@/pages/Scheduler";
import Billing from "@/pages/Billing";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return (
    <div className="h-screen flex items-center justify-center text-sm text-[#52525B]">
      Loading DentOS…
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/:pid" element={<PatientDetail />} />
            <Route path="scheduler" element={<Scheduler />} />
            <Route path="billing" element={<Billing />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
